import React from "react";
import AdminSelect from "./AdminSelect";
import ColorPicker from "./ColorPicker";
import { SIGNUP_TEXT_SLOTS, FONT_OPTIONS } from "../utils/signupTextStyle";

/**
 * Per-line styling editor for the four signup text slots (hero headline/subtitle
 * and first-step title/subtitle): show/hide, per-line font and colour. Style
 * only — the actual copy is edited elsewhere. Shared so the client Branding
 * page and the admin venue page share one control and can't drift.
 *
 *   value:    venue.signup_text_styles  ({ [slotKey]: { enabled, font, color } })
 *   onChange: (nextStyles) => void
 */
export default function SignupTextStyleEditor({ value, onChange }) {
  const styles = value || {};
  const setSlot = (key, patch) => {
    const next = { ...(styles[key] || {}), ...patch };
    Object.keys(next).forEach((k) => next[k] === undefined && delete next[k]);
    onChange({ ...styles, [key]: next });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "0.6rem" }}>
      {SIGNUP_TEXT_SLOTS.map((slot) => {
        const s = styles[slot.key] || {};
        const enabled = s.enabled !== false;
        return (
          <div key={slot.key} style={{ border: "1px solid var(--border)", borderRadius: 10, padding: "0.7rem 0.8rem", opacity: enabled ? 1 : 0.6 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "0.75rem" }}>
              <span style={{ fontSize: "0.85rem", fontWeight: 600 }}>{slot.label} <span className="optional">— {slot.group}</span></span>
              <label className="toggle-switch" style={{ cursor: "pointer" }} title={enabled ? "Shown on the signup" : "Hidden"}>
                <input type="checkbox" checked={enabled} onChange={(e) => setSlot(slot.key, { enabled: e.target.checked })} />
                <span className="toggle-track" />
              </label>
            </div>
            <div className="form-grid-2" style={{ marginTop: "0.55rem" }}>
              <div className="form-field" style={{ margin: 0 }}>
                <label style={{ fontSize: "0.76rem" }}>Font <span className="optional">— inherit</span></label>
                <AdminSelect
                  value={s.font || ""}
                  onChange={(v) => setSlot(slot.key, { font: v || undefined })}
                  options={[{ value: "", label: "Use venue font" }, ...FONT_OPTIONS.map((f) => ({ value: f, label: f }))]}
                  disabled={!enabled}
                />
              </div>
              <div className="form-field" style={{ margin: 0 }}>
                <label style={{ fontSize: "0.76rem" }}>Colour <span className="optional">— inherit</span></label>
                <div style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
                  <ColorPicker value={s.color || ""} onChange={(v) => setSlot(slot.key, { color: v || undefined })} compact />
                  {s.color && <button type="button" className="btn btn-outline btn-sm" onClick={() => setSlot(slot.key, { color: undefined })}>Reset</button>}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
